import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface AutomationDriftWarningRequest {
  resource: string;
  operation: string;
  itemName?: string;
}

export interface AutomationDriftWarningState extends AutomationDriftWarningRequest {
  confirmed: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class AutomationDriftWarningService {
  private resolver?: (confirmed: boolean) => void;
  private readonly stateSubject = new BehaviorSubject<AutomationDriftWarningState | null>(null);

  readonly state$ = this.stateSubject.asObservable();

  confirm(request: AutomationDriftWarningRequest): Promise<boolean> {
    if (this.resolver) {
      this.resolver(false);
    }

    this.stateSubject.next({
      ...request,
      confirmed: false,
    });

    return new Promise<boolean>((resolve) => {
      this.resolver = resolve;
    });
  }

  setConfirmed(confirmed: boolean): void {
    const state = this.stateSubject.value;
    if (!state) {
      return;
    }

    this.stateSubject.next({
      ...state,
      confirmed,
    });
  }

  proceed(): void {
    this.close(true);
  }

  cancel(): void {
    this.close(false);
  }

  private close(confirmed: boolean): void {
    this.resolver?.(confirmed);
    this.resolver = undefined;
    this.stateSubject.next(null);
  }
}
